<template>
  <div class="about">
    <div class="about-us">
      <h2>关于我们</h2>
      <div class="us-content">
        广东一匠科技有限公司【简称：一匠科技】成立于2014年，专注于为企业或政府提供全面互联网软件技术解决方案，包括APP研发、小程序研发、微信公众号研发、网站研发、企业信息系统研发及智能硬件等服务。目前团队人数约为50人，其中85%员工为技术人员。在广州,技术人员人数约10人，专注负责孵化器内的高新技术项目。公司拥有10年以上经验高级系统分析师、高级软件架构师、开发工程师、设计工程师与测试工程师等高级软件工程师组成核心团队，并设有产品经理与售后技术支持等专业性岗位。
        一匠科技是腾讯大粤网旗下腾讯房产于惠州地区技术研发中心，是惠州市软件协会旗下软件分发中心的总负责商，是惠州学院的实践教学基地，是惠州市技师学院与惠州经济职业技术学校的校企合作单位。
        一匠科技以“实现客户商业成功”为使命，凭借专业知识强、业务技术精、服务质量高、反应灵敏等特点，对客户商业模式优化，为客户产品保驾护航。
      </div>
    </div>
    <div class="about-culture">
      <h2>企业文化</h2>
      <div class="culture-content clearfix">
        <address class="content-item">
          <img src="../../static/images/about_mobile/1.png" />
          <h3>企业使命</h3>
          <h4>为客户提供专业的数字化解决<br />方案,实现客户的商业成功</h4>
        </address>
        <address class="content-item">
          <img src="../../static/images/about_mobile/2.png" />
          <h3>企业愿景</h3>
          <h4>成为客户的商业护航者<br />成为员工的价值领航者</h4>
        </address>
        <address class="content-item">
          <img src="../../static/images/about_mobile/3.png" />
          <h3>行为标准</h3>
          <h4>细节决定成败，协作<br />创造价值，效率成就品牌</h4>
        </address>
        <address class="content-item">
          <img src="../../static/images/about_mobile/4.png" />
          <h3>核心价值观</h3>
         <h4>客户为本，需求为先<br />体验为重，商业为根</h4>
        </address>
        <address class="content-item">
          <img src="../../static/images/about_mobile/5.png" />
          <h3>经营理念</h3>
          <h4>匠心研发<br />倾力服务</h4>
        </address>
        <address class="content-item">
          <img src="../../static/images/about_mobile/6.png" />
          <h3>企业精神</h3>
          <h4>匠心研发<br />倾力服务</h4>
        </address>
      </div>
    </div>
    <!-- <div class="about-history">
      <div class="history-title">
        <h2>发展历程</h2>
      </div>

      <div class="swiper-container" ref="slider">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="item in developList"
            :key="'develop' + item.id"
          >
            <div class="swiper-item">
              <address
                :class="{ show: show == item.id }"
                @click="active(item.id)"
              >
                <span>{{ item.year }}</span>
                <div
                  class="nav-yuan"
                  :class="{ hidden: show == item.id }"
                ></div>
                <img
                  :class="{ hidden: show != item.id }"
                  src="../../static/images/about_mobile/8.png"
                />
              </address>
            </div>
          </div>
        </div>
      </div>

      <div v-if="show == 1" class="history-content">
        <h3>2012年12月 “桔色柳丁”软件实验室</h3>
        <h4>
          2012年，郭乐彬创立了"桔色柳丁"软件实验室，高峰期拥有超过30人的学生团队。
        </h4>
      </div>
      <div v-else-if="show == 2" class="history-content">
        <h3>2014年4月 惠州市微城叁度科技有限公司</h3>
        <h4>
          2014年，郭乐彬、杨雅岚创立了惠州市微城叁度科技有限公司，以自研互联网产品“独处”获得了第一次天使投资。
        </h4>
      </div>
      <div v-else-if="show == 3" class="history-content">
        <h3>2017年4月 惠州市一匠科技有限公司</h3>
        <h4>
          2017年4月，惠州市微城叁度科技有限公司成功更名惠州市一匠科技有限公司，获得了第二次天使投资。
        </h4>
      </div>
      <div v-else-if="show == 4" class="history-content">
        <h3>2018年10月 惠州亿匠邦教育科技有限公司</h3>
        <h4>
          2018年10月，惠州市一匠科技有限公司入资惠州亿匠邦教育科技有限公司，并为一匠科技等企业输送高新技术人才，并且成功实现了5年规划的第二小步。
        </h4>
      </div>
      <div v-else-if="show == 5" class="history-content">
        <h3>2019年11月 惠州市软件分发中心</h3>
        <h4>
          2019年11月，惠州市一匠科有限公司与惠州软件开发协会共同成立惠州市软件分发中心，并成为惠州市软件分发中心战略合作总负责商，对推动惠州软件和信息技术服务业的产业化、规模化发展具有重大意义。
        </h4>
        <h3>2019年12月 校外实践教育基地</h3>
        <h4>
          2020年11月，亿匠邦教育科技与惠州技师学院成立了亿匠软件工作室，为技师学院培养更高素质人才
        </h4>
      </div>
      <div v-else-if="show == 6" class="history-content">
        <h3>2020年8月 广东一匠科技有限公司</h3>
        <h4>
          2020年8月，广东一匠科技广州市天河区正式成立，为一匠科技在珠三角的互联网影响力再一次扩大。
        </h4>
        <h3>2020年11月 亿匠软件工作室</h3>
        <h4>
          2020年11月，亿匠邦教育科技与惠州经济职业技术学院成立了亿匠软件工作室，为学院培养更高素质人才。
        </h4>
      </div>
    </div> -->
    <div class="about-honor">
      <h2>企业荣誉</h2>

      <div class="honor-content clearfix">
        <address
          class="content-nav clearfix"
          v-for="honor in honorList"
          :key="honor.id"
          @click="qiehuan(honor.id)"
          :class="{ qie: dong == honor.id }"
        >
          {{ honor.nav }}
          <div class="border"></div>
        </address>
        <address
          class="content-li clearfix"
          v-for="(child, index) in honorList[this.dong].child"
          :key="index + 10"
        >
          <div class="left"></div>
          <h4>{{ child.content }}</h4>
        </address>
      </div>
    </div>
    
    <div class="about-copyright">
      <h2>软件著作权</h2>
      <div class="copyright-content" id="parent">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="copy in copyList" :key="copy.id">
              <img :src="copy.image" class="bannerImg" />
            </div>
          </div>
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
    </div>
    <div class="about-team">
      <h2>团队风采</h2>
      <div class="team-content" id="parent">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(team, index) in teamList"
              :key="'team' + index"
            >
              <img :src="team.image" class="bannerImg" />
            </div>
          </div>
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
    </div>
    <div class="about-contact">
      <h2>联系我们</h2>
      <div class="contact-content">
        <address class="content-item">
          <img src="../../static/images/about_mobile/12.png" />
          <h4>手机：13824289487</h4>
        </address>
        <address class="content-item">
          <img src="../../static/images/about_mobile/13.png" />
          <h4>邮箱：eartisan@163.com</h4>
        </address>
        <address class="content-item">
          <img src="../../static/images/about_mobile/14.png" />
          <h4>地址：惠城区四环南路3号读者文化园 E座1204</h4>
        </address>
        <!-- <address class="content-item">
          <img src="../../static/images/about_mobile/14.png" />
          <h4>地址：广东省广州市天河区荷光路137号三楼</h4>
        </address> -->
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "aboutCenter",

  data() {
    return {
      show: 1,
      dong: 0,
      mySwiper: null,
      mySwiper1: null,
      otherSwiper: null,
      developList: [
        {
          id: 1,
          year: 2012,
        },
        {
          id: 2,
          year: 2014,
        },
        {
          id: 3,
          year: 2017,
        },
        {
          id: 4,
          year: 2018,
        },
        {
          id: 5,
          year: 2019,
        },
        {
          id: 6,
          year: 2020,
        },
      ],
    };
  },
  mounted() {
    this.mySwiper = new Swiper(".copyright-content .swiper-container", {
      observer: true,
      observeParents: true,
      // slidesPerView: "auto",
      effect: "coverflow",
      initialSlide: 0,
      coverflowEffect: {
        rotate: 0, //滑动时旋转角度
        stretch: 6.1, //聚合宽度
        depth: 10, //景深
        modifier: 30, //覆盖叠加层数
        slideShadows: false, //是否阴影
      },
      pagination: {
        el: ".copyright-content .swiper-pagination",
        clickable: true,
        bulletClass: "swiper-pagination-customs",
        bulletActiveClass: "swiper-pagination-customs-active",
      },
    });
    this.otherSwiper = new Swiper(".about-history .swiper-container", {
      slidesPerView: 5,
      initialSlide: 2,
      centeredSlides: true,
      loop: false,
    });
  },
  methods: {
    active: function (index) {
      this.show = index;
    },
    qiehuan: function (id) {
      this.dong = id;
    },
    freshSwiper() {
      this.mySwiper1 = new Swiper(".team-content .swiper-container", {
        observer: true,
        observeParents: true,
        slidesPerView: 1.2,
        initialSlide:0,

        pagination: {
          el: ".team-content .swiper-pagination",
          clickable: true,
          bulletClass: "swiper-pagination-customs",
          bulletActiveClass: "swiper-pagination-customs-active",
        },
      });
    },
  },
  props: {
    honorList: Array,
    teamList: Array,
    copyList: Array,
  },
};
</script>

<style lang="stylus" scoped>
@import '../../../node_modules/swiper/dist/css/swiper.css';
@import '~styles/varible.styl';

.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}

.about {
  letter-spacing: 1px;
  margin: 0 auto;
  text-align: center;
  font-family: PingFang SC;
}

h2 {
  font-size: 19px;
  font-weight: 800;
}

h4 {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
}

.about-us {
  margin-top: 10%;

  .us-content {
    margin: 0 auto;
    text-align: justify;
    text-align-last: left;
    width: 92%;
    margin-top: 5%;
    font-size: 12px;
    line-height: 20px;
  }
}

.about-culture {
  margin-top: 10%;

  .culture-content {
    width: 92%;
    margin: 0 auto;
    margin-top: 5%;
    border-bottom: 1px solid #E1E6F0;
    border-right: 1px solid #E1E6F0;

    .content-item {
      width: 50%;
      float: left;
      background: #FFFFFF;
      border-top: 1px solid #E1E6F0;
      border-left: 1px solid #E1E6F0;
      box-sizing: border-box;

      img {
        margin-top: 16%;
        margin-bottom: 12%;
      }

      h3 {
        font-size: 14px;
        font-weight: bold;
        line-height: 14px;
        margin-bottom: 5%;
      }

      h4 {
        margin-bottom: 13%;
        color: #666666;
      }
    }
  }
}

.about-history {
  margin-top: 15%;
  position: relative;
  overflow:hidden;

  .swiper-container {
    margin-top: -60px;
    overflow: visible !important;
    z-index: 0 !important;

    .swiper-wrapper {
      top: -30px;
      position: relative;
    }

    .swiper-wrapper:before {
      position: absolute;
      top: 35%;
      content: '';
      width: 120%;
      height: 3px;
      background: #FFC000;
    }

    .swiper-item {
      font-size: 13px;
      font-weight: 500;
      color: #FFFFFF;
    }

    .hidden {
      visibility: hidden;
    }

    .nav-yuan {
      width: 6px;
      height: 6px;
      background: #FFC000;
      border-radius: 50%;
      margin-left: 42%;
      margin-top: 14%;
    }

    .show {
      span {
        font-size: 15px;
        font-weight: bold;
        color: #FFC000;
      }

      img {
        position: absolute;
        top: 60%;
        left: 40%;
      }
    }
  }

  .history-title {
    padding-top: 5%;
    background-image: url('../../static/images/about_mobile/7.png');
    color: #FFFFFF;
    height: 175px;
    box-sizing: border-box;

    .title-nav {
      position: absolute;
      top: 20rpx;
      width: 92%;
      margin: -50% auto 0;
      margin-top: 5%;
      padding-bottom: 3%;
      border-bottom: 2px solid #FFC000;
    }
  }

  .history-content {
    width: 92%;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(111, 111, 111, 0.1);
    border-radius: 5px;
    text-align: left;
    position: relative;
    top: -40px;
    left: 4%;
    padding: 2% 6% 6% 6%;

    h3 {
      font-size: 14px;
      font-weight: bold;
      line-height: 14px;
      margin-top: 7%;
    }

    h4 {
      color: #666666;
      margin-top: 2%;
    }
  }
}

.about-honor {
  margin-top:20px;
  h2 {
    line-height: 19px;
  }

  .honor-content {
    width: 92%;
    margin: 0 auto;
    margin-top: 6%;

    .content-nav {
      float: left;
      font-size: 15px;
      font-weight: 500;
      color: #666666;
      margin: 0 1%;
      margin-bottom: 2%;
      position: relative;
    }

    .qie {
      font-weight: bold;
      color: #333333;

      .border {
        width: 17px;
        position: absolute;
        top: 150%;
        left: 50%;
        transform: translateX(-50%);
        border-bottom: 2px solid #FFC000;
      }
    }

    .content-li {
      margin-top: 3%;
      text-align: left;
      float: left;
      display: block;
      width: 100%;

      .left {
        display: inline-block;
        width: 4px;
        height: 4px;
        background: #FFC000;
        border-radius: 50%;
        float: left;
        margin-top: 7.5px;
      }

      h4 {
        width: 96%;
        display: inline-block;
        float: left;
        margin-left: 7px;
      }
    }
  }
}

.about-copyright {
  margin-top: 10%;
  position: relative;

  .swiper-container {
    position: relative;
    padding: 5% 0;
    width: 92%;

    .swiper-slide {
      width: 80%;

      img {
        width: 180px;
      }
    }
  }
}

#parent>>>.swiper-pagination {
  width: 100%;
  margin: 0 auto;
  top: 97%;

  .swiper-pagination-customs {
    display: inline-block;
    width: 8px;
    height: 4px;
    background: #EEEEEE;
    border-radius: 2px;
    margin-left: 5px;
    outline: 0 none !important;
  }

  .swiper-pagination-customs-active {
    width: 16px;
    height: 4px;
    background: #FFC000;
    border-radius: 2px;
  }
}

.about-team {
  margin-top: 10%;
  position: relative;

  .swiper-container {
    position: relative;
    padding: 5% 0;
    width: 92%;

    .swiper-slide {
      width: 100%;
      border-radius: 0;

      img {
        width: 95%;
      }
    }
  }
}

.about-contact {
  margin: 10% auto;

  .contact-content {
    margin-top: 3%;

    .content-item {
      text-align: left;
      letter-spacing: 0;

      img {
        margin: 2% 3%;
      }

      h4 {
        display: inline-block;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/AboutCenter.vue